import { combineReducers } from 'redux';

import { Api } from '../../../core/api';

const menuItemApi = new Api({
  initialData: { data: {} },
  namespace: 'MENU_ITEM',
  useEagleApi: true,
});

export const fetchAdminMenuItem = (id: string) =>
  menuItemApi.fetch({
    url: `/internal-intranet/menu/${id}`,
  });

export const resetAdminMenuInfo = menuItemApi.reset;

const createMenuApi = new Api({
  options: {
    method: 'POST',
  },
  url: `/internal-intranet/menu`,
  useEagleApi: true,
});

const updateMenuApi = new Api({
  options: {
    method: 'PUT',
  },
  url: `/internal-intranet/menu`,
  useEagleApi: true,
});

const deleteMenuApi = new Api({
  options: {
    method: 'DELETE',
  },
  url: '/internal-intranet/menu',
  throwable: true,
  useEagleApi: true,
});

const bulkUpdateMenuApi = new Api({
  options: {
    method: 'POST',
  },
  url: '/menu/bulk-update',
});

export const bulkUpdateAdminMenu = (menu: any) =>
  bulkUpdateMenuApi.simpleFetch({
    options: { body: JSON.stringify(menu) },
  });

export const createAdminMenu = (data: any) =>
  createMenuApi.simpleFetch({ options: { body: JSON.stringify(data) } });

export const deleteAdminMenuItem = (id: string) =>
  deleteMenuApi.simpleFetch({
    options: { body: JSON.stringify({ ids: [id] }) },
  });

export const updateAdminMenu = (id: string, data: any) =>
  updateMenuApi.simpleFetch({
    options: { body: JSON.stringify(data) },
    url: `/internal-intranet/menu/${id}`,
  });

const newMenuItemsApi = new Api({
  initialData: { items: [] },
  namespace: 'NEW_ADMIN_MENU_ITEMS',
  url: '/internal-intranet/menu',
  useEagleApi: true,
});

export const fetchAdminMenu = (parentMenuItemId: string) =>
  newMenuItemsApi.fetch({
    urlParams: `?parentId=${parentMenuItemId}&admin=true`,
  });

const newNestedSideMenuApi = new Api({
  useEagleApi: true,
  namespace: 'NEW_NESTED_SIDE_MENU_ITEMS',
  url: '/internal-intranet/menu',
});
export const fetchNestedAdminMenu = (parentMenuItemId: string) => {
  return newNestedSideMenuApi.fetch({
    urlParams: `?parentId=${parentMenuItemId}&admin=true`,
  });
};

export const reducer = combineReducers({
  menuItem: menuItemApi.reducer,
  adminMenu: newMenuItemsApi.reducer,
});
